import { deleteMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_LEAD_CAPTURE = 'DELETE_LEAD_CAPTURE';
export const DELETE_LEAD_CAPTURE_SUCCESS = 'DELETE_LEAD_CAPTURE_SUCCESS';
export const DELETE_LEAD_CAPTURE_FAILURE = 'DELETE_LEAD_CAPTURE_FAILURE';

// Action Creators
export const deleteLeadCapture = () => ({
  type: DELETE_LEAD_CAPTURE,
});

export const deleteLeadCaptureSuccess = (data) => ({
  type: DELETE_LEAD_CAPTURE_SUCCESS,
  payload: data,
});

export const deleteLeadCaptureFailure = (error) => ({
  type: DELETE_LEAD_CAPTURE_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteLeadCaptureCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(deleteLeadCapture());
    try {
      const response = await deleteMethodWithToken(
        url.leadCapture + data + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(deleteLeadCaptureSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(deleteLeadCaptureFailure(response?.data));
      }
    } catch (error) {
      dispatch(deleteLeadCaptureFailure(error?.message));
    }
  };
};
